'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sword';
var width = 512;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = ['M22.5 412.8l76.7 76.7L112 476.7l0-36.7 0-3.3 2.3-2.3 48-48 4.4-4.4 5.4 3.2 74.6 44.8L268.7 408 104 243.3 82.1 265.2l44.8 74.6 3.2 5.4-4.4 4.4-48 48L75.3 400 72 400l-36.7 0L22.5 412.8zM177.9 260.7c24.5 24.5 48.9 48.9 73.4 73.4L480.9 104.5l12.2-85.6L407.5 31.1 177.9 260.7z', 'M262.6 345.4L496 112l13.6-95.5L512 0 495.5 2.4 400 16 166.6 249.4l11.3 11.3L407.5 31.1l85.6-12.2-12.2 85.6L251.3 334.1l11.3 11.3zm-153-119l-5.7-5.7-5.7 5.7-32 32-4.4 4.4 3.2 5.4 44.8 74.6L68.7 384 32 384l-3.3 0-2.3 2.3L5.5 407.1l-5.7 5.7 5.7 5.7 88 88 5.7 5.7 5.7-5.7 20.8-20.8 2.3-2.3 0-3.3 0-36.7 41.2-41.2 74.6 44.8 5.4 3.2 4.4-4.4 32-32 5.7-5.7-5.7-5.7-176-176zm17.2 113.5L82.1 265.2 104 243.3 268.7 408l-21.9 21.9-74.6-44.8-5.4-3.2-4.4 4.4-48 48-2.3 2.3 0 3.3 0 36.7L99.2 489.5 22.5 412.8 35.3 400 72 400l3.3 0 2.3-2.3 48-48 4.4-4.4-3.2-5.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;